import {MAPPA} from './MappaTypes'

const initialState = {
    mappa : {}
}

const MappaReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case MAPPA:
            
            return {
                mappa : action.load
            }
    
        default:
          return state
    }

}

export default MappaReducer;